module.exports = __webpack_public_path__ + "static/media/quiz.0f692766.mp3";